module.exports = __webpack_public_path__ + "static/media/close_ico.644d4812.svg";